/**
 * CMSD static header name.
 *
 * @group CMSD
 *
 * @beta
 */
export const CMSD_STATIC = 'CMSD-Static';
